import './shared/base_styles';
import './shared/marketing_analytics';

import { ClientWWW } from '@root/root/www/client';

import { mountApp } from './shared/mount_app';

mountApp(ClientWWW);
